import React, { Component, createRef } from "react";
import Button from "@material-ui/core/Button";
import FetchServerData from "../../../provider/FetchServerData";
import BlackbaudLogo from "../../../assets/img/blackbaudDonation.png";
import logo from "../../../assets/img/givebelogo.png";
import PtsAlert from "../ptsAlert/PtsAlert";
class BlackbaudDonation extends Component {
  constructor(props) {
    super(props);
    const str = new URLSearchParams(window.location.search);
    const urlTid = str.get("t");
    const twilioLogId = str.get("i");
    const amount = str.get("amount");

    this.state = {
      urlTid: urlTid,
      twilioLogId: twilioLogId,
      amount: amount,
      phone: "",
      businessEmail: "",
      messageName: "",
      publicKey: "",
      configurationId: "",
      organization: null,
      notifyUrl: null,
      render: false,
      isPledge: false,
      isAmount: amount === null ? true : false,
      isPaymentSuccessfull: false,
      isPaymentFailed: false,
    };
    this.getMessageLogDetails(urlTid, twilioLogId);
  }

  getMessageLogDetails(urlTid, twilioLogId) {
    const postObject = {
      header: { tid: urlTid },
      twilioSmsLog: {
        id: twilioLogId,
      },
    };
    FetchServerData.callPostService("/smsLogms/get", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let smsLogDeatils = output.data;
          let twilioSmsLogDeatils = smsLogDeatils.twilioSmsLog;
          let organizationDetails = twilioSmsLogDeatils?.organization;
          let messageDetails = twilioSmsLogDeatils?.messageLog?.message;
          this.setState({
            render: true,
            organization: organizationDetails,
            twilioLogId: twilioSmsLogDeatils.id,
            notifyUrl: twilioSmsLogDeatils.pledgeCallbackUrl,
            businessEmail: organizationDetails?.paymentPaypal?.paypalid,
            messageName: messageDetails.messageName,
            isPledge: messageDetails.isPledge,
            publicKey: smsLogDeatils.publicKey,
            configurationId: smsLogDeatils.configuration?.id,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  handleAmountChange = (event) => {
    this.setState({ amount: event.target.value });
  };

  handleDonateNow = (event) => {
    event.preventDefault();

    if (!this.state.amount || this.state.amount <= 0) {
      alert("Please enter a valid amount.");
      return;
    }

    let transactionData = {
      key: this.state.publicKey, // Pass via props
      PaymentConfigurationId: this.state.configurationId, // Pass via props
      Amount: this.state.amount,
    };

    // Open Blackbaud Checkout
    window.Blackbaud_OpenPaymentForm(transactionData);

  };

  componentDidMount() {
    // Check if Blackbaud script is already loaded
    if (
      !document.querySelector(
        'script[src="https://payments.blackbaud.com/Checkout/bbCheckout.2.0.js"]'
      )
    ) {
      const script = document.createElement("script");
      script.src = "https://payments.blackbaud.com/Checkout/bbCheckout.2.0.js";
      script.async = true;
      script.onload = () => console.log("Blackbaud Checkout script loaded.");
      document.body.appendChild(script);
    }

    // Attach event listeners for checkout events
    document.addEventListener("checkoutComplete", this.handleCheckoutComplete);
    document.addEventListener("checkoutError", this.handleCheckoutError);
  }

  componentWillUnmount() {
    // Cleanup event listeners
    document.removeEventListener(
      "checkoutComplete",
      this.handleCheckoutComplete
    );
    document.removeEventListener("checkoutError", this.handleCheckoutError);
  }

  handleCheckoutComplete = (event) => {
    console.log(event)
    const data = event?.detail;
    console.log(data)
    const postObject = {
      header: { tid: this.state.urlTid },
      tid: this.state.urlTid,
      outgoingMessageLogId: this.state.twilioLogId,
      checkoutToken: data.transactionToken,
      amount: data.authorizedamount,
    };

    FetchServerData.callPostService("/bbPaymentms/paymentSuccessful", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.setState({
            render: true,
            isPaymentSuccessfull: true,
            isPaymentFailed: false,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  handleCheckoutError = (event) => {
    console.log(event)
    const data = event?.detail;
    console.log(data)
    const postObject = {
      header: { tid: this.state.urlTid },
      tid: this.state.urlTid,
      outgoingMessageLogId: this.state.twilioLogId,
      checkoutToken: data.transactionToken,
      amount: data.authorizedamount,
      errorCode: data.errorCode,
      errorMessage: data.errorText,
    };

    FetchServerData.callPostService("/bbPaymentms/paymentFailed", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.setState({
            render: true,
            isPaymentFailed: true,
            isPaymentSuccessfull: false,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  render() {
    const { notifyUrl, amount, isAmount, isPledge } = this.state;
    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <div className="row m-4 justify-content-center">
          <div className="col-md-3">
            <div className="row">
              <div className="col-md-12 text-center" id="assetFormLabel">
                <div
                  style={{
                    display: "inline-flex",
                  }}
                >
                  {this.state.organization?.orgLogoDocument?.url !== null ? (
                    <a href="http://localhost:3000/" target="_blank">
                      <img
                        src={this.state.organization?.orgLogoDocument?.url}
                        style={{
                          width: "300Px",
                          height: "80px",
                          objectFit: "contain",
                        }}
                        alt="logo"
                      />
                    </a>
                  ) : (
                    <spna
                      style={{
                        fontSize: "20px",
                        fontWeight: "600",
                        color: "#353538",
                      }}
                    >
                      {this.state.organization?.name}
                    </spna>
                  )}
                </div>
              </div>
            </div>
            <div className="row p-4 justify-content-center">
              <div className="col-md-12">
                {this.state.isPaymentSuccessfull || this.state.isPaymentFailed ?
                  <div className="row mt-4">
                    {this.state.isPaymentSuccessfull &&
                      <div className="col-sm-12 text-center" style={{ fontSize: "18px", color: "green", fontWeight: "700" }}> Payment successful. Thank you! </div>
                    }
                    {this.state.isPaymentFailed &&
                      <div className="col-sm-12 text-center" style={{ fontSize: "18px", color: "red", fontWeight: "700" }}> Payment failed. Please try again. </div>
                    }
                  </div>
                  :
                  <div id="donationform">
                    <input
                      type="hidden"
                      name="notify_url"
                      id="notify_url"
                      value={notifyUrl}
                    />
                    {isAmount && (
                      <div className="amount-wrapper pt-4 pb-4">
                        <label className="amount-label">Enter amount:</label>
                        <div className="input-container">
                          <span className="dollar-sign">$</span>
                          <input
                            type="number"
                            name="amount"
                            id="amount"
                            autoComplete="off"
                            className="amount-input"
                            value={amount}
                            onChange={this.handleAmountChange}
                          />
                        </div>
                      </div>
                    )}
                    <div className="text-center p-3">
                      {amount > 0 ? (
                        // <Button
                        //   type="button"
                        //   id="donate-now"
                        //   onClick={this.handleDonateNow}
                        //   className="me-2"
                        //   style={{
                        //     padding: "2px 10px",
                        //     background: "#337ab7",
                        //     color: "#fff",
                        //     fontSize: "14px",
                        //     fontWeight: "600",
                        //     width: "150px",
                        //     textTransform: "capitalize",
                        //   }}
                        // >
                        //   Donate {amount ? `$${parseFloat(amount)}` : ""}
                        // </Button>
                        <button
                          className="give-button"
                          type="button"
                          id="donate-now"
                          onClick={this.handleDonateNow}
                        >
                          <b>
                            <i>Give {amount ? `$${parseFloat(amount)}` : ""}</i>
                          </b>
                        </button>
                      ) : (
                        <button
                          className="give-button"
                          type="button"
                          id="donate-now"
                          disabled
                        // onClick={this.handleDonateNow}
                        >
                          <b>
                            <i>Give</i>
                          </b>
                        </button>
                      )}
                    </div>
                  </div>
                }
              </div>
            </div>
            <div className="row justify-content-center">
              <img
                src={BlackbaudLogo}
                alt="#"
                class="logo"
                style={{ height: "80px", objectFit: "contain" }}
              />

              <br />
              <a
                href="http://www.givbee.com/"
                class="text-center mt-3 donationfooter-text"
                target="_blank"
              >
                <span className="mb-2">Texting provided by GivBee</span> <br />
                <span>www.givbee.com</span>
                {/* <img
                  style={{ height: "30px", objectFit: "contain" }}
                  src={logo}
                  alt="#"
                /> */}
              </a>
            </div>
          </div>
        </div>
      );
    }
  }
}
export default BlackbaudDonation;
